var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"category-list"},_vm._l((_vm.categoryList),function(item){return _c('li',{key:item?.code},[_c('a',{staticClass:"category-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _setup.onClickItem(item)}}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }